import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: { width: '70%' },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'block',
  },
  colBoxes: {
    display: 'flex',
    gap: theme.spacing(3),
    flexDirection: 'column',
  },
}))
